import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';

// Types for Azure ERP import status
const FileInfoRuntype = z.object({
    filename: z.string(),
    creation_time: z.string(),
    status: z.enum(['Success', 'Failure', 'InProgress']),
});

const FileTypeStatusRuntype = z.object({
    last_processed: FileInfoRuntype.nullable(),
    currently_processing: FileInfoRuntype.nullable(),
});

const ImportStatusResponseRuntype = z.object({
    components: FileTypeStatusRuntype,
    inventory: FileTypeStatusRuntype,
});

// Export types for use in components
export type FileInfo = z.infer<typeof FileInfoRuntype>;
export type FileTypeStatus = z.infer<typeof FileTypeStatusRuntype>;
export type ImportStatusResponse = z.infer<typeof ImportStatusResponseRuntype>;

// Azure endpoints definition
export const azureEndpoints = {
    'GET /azure-erp-files': endpoint({
        description: 'Get Azure ERP import status for components and inventory files.',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        responseBody: ImportStatusResponseRuntype,
        requestBody: z.undefined(),
        actionPermission: () => 'CanViewAzureErpFiles',
    }),
};
